import { render, staticRenderFns } from "./client-rules.vue?vue&type=template&id=d6d1ccb4&scoped=true&"
import script from "./client-rules.vue?vue&type=script&lang=js&"
export * from "./client-rules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d1ccb4",
  null
  
)

export default component.exports